/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * B2B Backend API
 * API documentation for B2B Platform
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  CoordinatorDraft,
  CoordinatorStatus,
  DealPanel,
  DealTimeLog,
  DealTimeLogCreateRequest,
  DealTimeLogList,
  DraftApproveRequest,
  DraftRejectRequest,
  FollowUpRequestRequest,
  FollowUpResponse,
  ModeratorsCoordinatorDraftsListParams,
  ModeratorsCoordinatorStalledRetrieveParams,
  PaginatedCoordinatorDraft,
  PaginatedDealStallFlag,
  StallScanRequestRequest,
  StallScanResult
} from '.././model'
import { customInstance } from '../../../../api/client';



/**
 * Per-deal coordinator panel and time log.
 * @summary Coordinator panel for a deal
 */
export const moderatorsCoordinatorDealsRetrieve = (
    id: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<DealPanel>(
      {url: `/api/v1/moderators/coordinator/deals/${id}/`, method: 'GET', signal
    },
      );
    }
  

export const getModeratorsCoordinatorDealsRetrieveQueryKey = (id: number,) => {
    return [`/api/v1/moderators/coordinator/deals/${id}/`] as const;
    }

    
export const getModeratorsCoordinatorDealsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof moderatorsCoordinatorDealsRetrieve>>, TError = void>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsCoordinatorDealsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getModeratorsCoordinatorDealsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof moderatorsCoordinatorDealsRetrieve>>> = ({ signal }) => moderatorsCoordinatorDealsRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: 30000, gcTime: 300000, refetchOnMount: true,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof moderatorsCoordinatorDealsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type ModeratorsCoordinatorDealsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof moderatorsCoordinatorDealsRetrieve>>>
export type ModeratorsCoordinatorDealsRetrieveQueryError = void

/**
 * @summary Coordinator panel for a deal
 */
export const useModeratorsCoordinatorDealsRetrieve = <TData = Awaited<ReturnType<typeof moderatorsCoordinatorDealsRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsCoordinatorDealsRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getModeratorsCoordinatorDealsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Asks the coordinator for follow-up messages to the buyer and/or supplier and stores them as pending drafts. Nothing is sent until a moderator approves a draft.
 * @summary Draft follow-ups into the approval queue
 */
export const moderatorsCoordinatorDealsDraftFollowUpCreate = (
    id: number,
    followUpRequestRequest: FollowUpRequestRequest,
 ) => {
      
      
      return customInstance<FollowUpResponse>(
      {url: `/api/v1/moderators/coordinator/deals/${id}/draftFollowUp/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: followUpRequestRequest
    },
      );
    }
  


export const getModeratorsCoordinatorDealsDraftFollowUpCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsCoordinatorDealsDraftFollowUpCreate>>, TError,{id: number;data: FollowUpRequestRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsCoordinatorDealsDraftFollowUpCreate>>, TError,{id: number;data: FollowUpRequestRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsCoordinatorDealsDraftFollowUpCreate>>, {id: number;data: FollowUpRequestRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  moderatorsCoordinatorDealsDraftFollowUpCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsCoordinatorDealsDraftFollowUpCreateMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsCoordinatorDealsDraftFollowUpCreate>>>
    export type ModeratorsCoordinatorDealsDraftFollowUpCreateMutationBody = FollowUpRequestRequest
    export type ModeratorsCoordinatorDealsDraftFollowUpCreateMutationError = void

    /**
 * @summary Draft follow-ups into the approval queue
 */
export const useModeratorsCoordinatorDealsDraftFollowUpCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsCoordinatorDealsDraftFollowUpCreate>>, TError,{id: number;data: FollowUpRequestRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsCoordinatorDealsDraftFollowUpCreate>>,
        TError,
        {id: number;data: FollowUpRequestRequest},
        TContext
      > => {

      const mutationOptions = getModeratorsCoordinatorDealsDraftFollowUpCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Per-deal coordinator panel and time log.
 * @summary Suggest next steps (moderator-only, cached)
 */
export const moderatorsCoordinatorDealsNextStepsCreate = (
    id: number,
 ) => {
      
      
      return customInstance<DealPanel>(
      {url: `/api/v1/moderators/coordinator/deals/${id}/nextSteps/`, method: 'POST'
    },
      );
    }
  


export const getModeratorsCoordinatorDealsNextStepsCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsCoordinatorDealsNextStepsCreate>>, TError,{id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsCoordinatorDealsNextStepsCreate>>, TError,{id: number}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsCoordinatorDealsNextStepsCreate>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  moderatorsCoordinatorDealsNextStepsCreate(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsCoordinatorDealsNextStepsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsCoordinatorDealsNextStepsCreate>>>
    
    export type ModeratorsCoordinatorDealsNextStepsCreateMutationError = void

    /**
 * @summary Suggest next steps (moderator-only, cached)
 */
export const useModeratorsCoordinatorDealsNextStepsCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsCoordinatorDealsNextStepsCreate>>, TError,{id: number}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsCoordinatorDealsNextStepsCreate>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getModeratorsCoordinatorDealsNextStepsCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Generates and caches an internal summary of the deal and its company messages. Never sent to companies. 503 when the coordinator is not configured.
 * @summary Summarise the deal thread (moderator-only, cached)
 */
export const moderatorsCoordinatorDealsSummarizeCreate = (
    id: number,
 ) => {
      
      
      return customInstance<DealPanel>(
      {url: `/api/v1/moderators/coordinator/deals/${id}/summarize/`, method: 'POST'
    },
      );
    }
  


export const getModeratorsCoordinatorDealsSummarizeCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsCoordinatorDealsSummarizeCreate>>, TError,{id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsCoordinatorDealsSummarizeCreate>>, TError,{id: number}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsCoordinatorDealsSummarizeCreate>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  moderatorsCoordinatorDealsSummarizeCreate(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsCoordinatorDealsSummarizeCreateMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsCoordinatorDealsSummarizeCreate>>>
    
    export type ModeratorsCoordinatorDealsSummarizeCreateMutationError = void

    /**
 * @summary Summarise the deal thread (moderator-only, cached)
 */
export const useModeratorsCoordinatorDealsSummarizeCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsCoordinatorDealsSummarizeCreate>>, TError,{id: number}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsCoordinatorDealsSummarizeCreate>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getModeratorsCoordinatorDealsSummarizeCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Per-deal coordinator panel and time log.
 * @summary List time logged on a deal
 */
export const moderatorsCoordinatorDealsTimeLogsRetrieve = (
    id: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<DealTimeLogList>(
      {url: `/api/v1/moderators/coordinator/deals/${id}/timeLogs/`, method: 'GET', signal
    },
      );
    }
  

export const getModeratorsCoordinatorDealsTimeLogsRetrieveQueryKey = (id: number,) => {
    return [`/api/v1/moderators/coordinator/deals/${id}/timeLogs/`] as const;
    }

    
export const getModeratorsCoordinatorDealsTimeLogsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof moderatorsCoordinatorDealsTimeLogsRetrieve>>, TError = unknown>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsCoordinatorDealsTimeLogsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getModeratorsCoordinatorDealsTimeLogsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof moderatorsCoordinatorDealsTimeLogsRetrieve>>> = ({ signal }) => moderatorsCoordinatorDealsTimeLogsRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: 30000, gcTime: 300000, refetchOnMount: true,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof moderatorsCoordinatorDealsTimeLogsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type ModeratorsCoordinatorDealsTimeLogsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof moderatorsCoordinatorDealsTimeLogsRetrieve>>>
export type ModeratorsCoordinatorDealsTimeLogsRetrieveQueryError = unknown

/**
 * @summary List time logged on a deal
 */
export const useModeratorsCoordinatorDealsTimeLogsRetrieve = <TData = Awaited<ReturnType<typeof moderatorsCoordinatorDealsTimeLogsRetrieve>>, TError = unknown>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsCoordinatorDealsTimeLogsRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getModeratorsCoordinatorDealsTimeLogsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Per-deal coordinator panel and time log.
 * @summary Log moderator time on a deal
 */
export const moderatorsCoordinatorDealsTimeLogsCreate = (
    id: number,
    dealTimeLogCreateRequest: DealTimeLogCreateRequest,
 ) => {
      
      
      return customInstance<DealTimeLog>(
      {url: `/api/v1/moderators/coordinator/deals/${id}/timeLogs/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: dealTimeLogCreateRequest
    },
      );
    }
  


export const getModeratorsCoordinatorDealsTimeLogsCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsCoordinatorDealsTimeLogsCreate>>, TError,{id: number;data: DealTimeLogCreateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsCoordinatorDealsTimeLogsCreate>>, TError,{id: number;data: DealTimeLogCreateRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsCoordinatorDealsTimeLogsCreate>>, {id: number;data: DealTimeLogCreateRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  moderatorsCoordinatorDealsTimeLogsCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsCoordinatorDealsTimeLogsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsCoordinatorDealsTimeLogsCreate>>>
    export type ModeratorsCoordinatorDealsTimeLogsCreateMutationBody = DealTimeLogCreateRequest
    export type ModeratorsCoordinatorDealsTimeLogsCreateMutationError = void

    /**
 * @summary Log moderator time on a deal
 */
export const useModeratorsCoordinatorDealsTimeLogsCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsCoordinatorDealsTimeLogsCreate>>, TError,{id: number;data: DealTimeLogCreateRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsCoordinatorDealsTimeLogsCreate>>,
        TError,
        {id: number;data: DealTimeLogCreateRequest},
        TContext
      > => {

      const mutationOptions = getModeratorsCoordinatorDealsTimeLogsCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * The approval queue. Nothing reaches a company until `approve`.
 * @summary List coordinator drafts (approval queue)
 */
export const moderatorsCoordinatorDraftsList = (
    params?: ModeratorsCoordinatorDraftsListParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PaginatedCoordinatorDraft[]>(
      {url: `/api/v1/moderators/coordinator/drafts/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getModeratorsCoordinatorDraftsListQueryKey = (params?: ModeratorsCoordinatorDraftsListParams,) => {
    return [`/api/v1/moderators/coordinator/drafts/`, ...(params ? [params]: [])] as const;
    }

    
export const getModeratorsCoordinatorDraftsListQueryOptions = <TData = Awaited<ReturnType<typeof moderatorsCoordinatorDraftsList>>, TError = unknown>(params?: ModeratorsCoordinatorDraftsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsCoordinatorDraftsList>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getModeratorsCoordinatorDraftsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof moderatorsCoordinatorDraftsList>>> = ({ signal }) => moderatorsCoordinatorDraftsList(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 30000, gcTime: 300000, refetchOnMount: true,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof moderatorsCoordinatorDraftsList>>, TError, TData> & { queryKey: QueryKey }
}

export type ModeratorsCoordinatorDraftsListQueryResult = NonNullable<Awaited<ReturnType<typeof moderatorsCoordinatorDraftsList>>>
export type ModeratorsCoordinatorDraftsListQueryError = unknown

/**
 * @summary List coordinator drafts (approval queue)
 */
export const useModeratorsCoordinatorDraftsList = <TData = Awaited<ReturnType<typeof moderatorsCoordinatorDraftsList>>, TError = unknown>(
 params?: ModeratorsCoordinatorDraftsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsCoordinatorDraftsList>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getModeratorsCoordinatorDraftsListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * The approval queue. Nothing reaches a company until `approve`.
 * @summary Get a coordinator draft
 */
export const moderatorsCoordinatorDraftsRetrieve = (
    id: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<CoordinatorDraft>(
      {url: `/api/v1/moderators/coordinator/drafts/${id}/`, method: 'GET', signal
    },
      );
    }
  

export const getModeratorsCoordinatorDraftsRetrieveQueryKey = (id: number,) => {
    return [`/api/v1/moderators/coordinator/drafts/${id}/`] as const;
    }

    
export const getModeratorsCoordinatorDraftsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof moderatorsCoordinatorDraftsRetrieve>>, TError = void>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsCoordinatorDraftsRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getModeratorsCoordinatorDraftsRetrieveQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof moderatorsCoordinatorDraftsRetrieve>>> = ({ signal }) => moderatorsCoordinatorDraftsRetrieve(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: 30000, gcTime: 300000, refetchOnMount: true,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof moderatorsCoordinatorDraftsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type ModeratorsCoordinatorDraftsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof moderatorsCoordinatorDraftsRetrieve>>>
export type ModeratorsCoordinatorDraftsRetrieveQueryError = void

/**
 * @summary Get a coordinator draft
 */
export const useModeratorsCoordinatorDraftsRetrieve = <TData = Awaited<ReturnType<typeof moderatorsCoordinatorDraftsRetrieve>>, TError = void>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsCoordinatorDraftsRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getModeratorsCoordinatorDraftsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Posts the (optionally edited) text exactly once: as a moderator message in the approver's conversation with the company, or as an in-app notification. Assigned moderator or super moderator only. `logMinutes` optionally logs review time on the deal.
 * @summary Approve a draft and post it
 */
export const moderatorsCoordinatorDraftsApproveCreate = (
    id: number,
    draftApproveRequest: DraftApproveRequest,
 ) => {
      
      
      return customInstance<CoordinatorDraft>(
      {url: `/api/v1/moderators/coordinator/drafts/${id}/approve/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: draftApproveRequest
    },
      );
    }
  


export const getModeratorsCoordinatorDraftsApproveCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsCoordinatorDraftsApproveCreate>>, TError,{id: number;data: DraftApproveRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsCoordinatorDraftsApproveCreate>>, TError,{id: number;data: DraftApproveRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsCoordinatorDraftsApproveCreate>>, {id: number;data: DraftApproveRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  moderatorsCoordinatorDraftsApproveCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsCoordinatorDraftsApproveCreateMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsCoordinatorDraftsApproveCreate>>>
    export type ModeratorsCoordinatorDraftsApproveCreateMutationBody = DraftApproveRequest
    export type ModeratorsCoordinatorDraftsApproveCreateMutationError = void

    /**
 * @summary Approve a draft and post it
 */
export const useModeratorsCoordinatorDraftsApproveCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsCoordinatorDraftsApproveCreate>>, TError,{id: number;data: DraftApproveRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsCoordinatorDraftsApproveCreate>>,
        TError,
        {id: number;data: DraftApproveRequest},
        TContext
      > => {

      const mutationOptions = getModeratorsCoordinatorDraftsApproveCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Marks the draft rejected. Nothing is posted.
 * @summary Reject a draft
 */
export const moderatorsCoordinatorDraftsRejectCreate = (
    id: number,
    draftRejectRequest: DraftRejectRequest,
 ) => {
      
      
      return customInstance<CoordinatorDraft>(
      {url: `/api/v1/moderators/coordinator/drafts/${id}/reject/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: draftRejectRequest
    },
      );
    }
  


export const getModeratorsCoordinatorDraftsRejectCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsCoordinatorDraftsRejectCreate>>, TError,{id: number;data: DraftRejectRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsCoordinatorDraftsRejectCreate>>, TError,{id: number;data: DraftRejectRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsCoordinatorDraftsRejectCreate>>, {id: number;data: DraftRejectRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  moderatorsCoordinatorDraftsRejectCreate(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsCoordinatorDraftsRejectCreateMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsCoordinatorDraftsRejectCreate>>>
    export type ModeratorsCoordinatorDraftsRejectCreateMutationBody = DraftRejectRequest
    export type ModeratorsCoordinatorDraftsRejectCreateMutationError = void

    /**
 * @summary Reject a draft
 */
export const useModeratorsCoordinatorDraftsRejectCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsCoordinatorDraftsRejectCreate>>, TError,{id: number;data: DraftRejectRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsCoordinatorDraftsRejectCreate>>,
        TError,
        {id: number;data: DraftRejectRequest},
        TContext
      > => {

      const mutationOptions = getModeratorsCoordinatorDraftsRejectCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Flags stalled deals with the deterministic rules (no LLM). Super moderators scan every deal; other moderators the deals assigned to them. `autoDraft` queues reminder drafts that still need approval. The same scan runs from `manage.py coordinator_stall_scan`.
 * @summary Run the stall scan
 */
export const moderatorsCoordinatorStallScanCreate = (
    stallScanRequestRequest: StallScanRequestRequest,
 ) => {
      
      
      return customInstance<StallScanResult>(
      {url: `/api/v1/moderators/coordinator/stallScan/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: stallScanRequestRequest
    },
      );
    }
  


export const getModeratorsCoordinatorStallScanCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsCoordinatorStallScanCreate>>, TError,{data: StallScanRequestRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsCoordinatorStallScanCreate>>, TError,{data: StallScanRequestRequest}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsCoordinatorStallScanCreate>>, {data: StallScanRequestRequest}> = (props) => {
          const {data} = props ?? {};

          return  moderatorsCoordinatorStallScanCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsCoordinatorStallScanCreateMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsCoordinatorStallScanCreate>>>
    export type ModeratorsCoordinatorStallScanCreateMutationBody = StallScanRequestRequest
    export type ModeratorsCoordinatorStallScanCreateMutationError = unknown

    /**
 * @summary Run the stall scan
 */
export const useModeratorsCoordinatorStallScanCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsCoordinatorStallScanCreate>>, TError,{data: StallScanRequestRequest}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsCoordinatorStallScanCreate>>,
        TError,
        {data: StallScanRequestRequest},
        TContext
      > => {

      const mutationOptions = getModeratorsCoordinatorStallScanCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * @summary List stalled deals (active flags)
 */
export const moderatorsCoordinatorStalledRetrieve = (
    params?: ModeratorsCoordinatorStalledRetrieveParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<PaginatedDealStallFlag>(
      {url: `/api/v1/moderators/coordinator/stalled/`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getModeratorsCoordinatorStalledRetrieveQueryKey = (params?: ModeratorsCoordinatorStalledRetrieveParams,) => {
    return [`/api/v1/moderators/coordinator/stalled/`, ...(params ? [params]: [])] as const;
    }

    
export const getModeratorsCoordinatorStalledRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof moderatorsCoordinatorStalledRetrieve>>, TError = unknown>(params?: ModeratorsCoordinatorStalledRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsCoordinatorStalledRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getModeratorsCoordinatorStalledRetrieveQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof moderatorsCoordinatorStalledRetrieve>>> = ({ signal }) => moderatorsCoordinatorStalledRetrieve(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 30000, gcTime: 300000, refetchOnMount: true,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof moderatorsCoordinatorStalledRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type ModeratorsCoordinatorStalledRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof moderatorsCoordinatorStalledRetrieve>>>
export type ModeratorsCoordinatorStalledRetrieveQueryError = unknown

/**
 * @summary List stalled deals (active flags)
 */
export const useModeratorsCoordinatorStalledRetrieve = <TData = Awaited<ReturnType<typeof moderatorsCoordinatorStalledRetrieve>>, TError = unknown>(
 params?: ModeratorsCoordinatorStalledRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsCoordinatorStalledRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getModeratorsCoordinatorStalledRetrieveQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Whether the LLM features are configured, the provider / model, the stall thresholds and the default review minutes.
 * @summary Coordinator status
 */
export const moderatorsCoordinatorStatusRetrieve = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<CoordinatorStatus>(
      {url: `/api/v1/moderators/coordinator/status/`, method: 'GET', signal
    },
      );
    }
  

export const getModeratorsCoordinatorStatusRetrieveQueryKey = () => {
    return [`/api/v1/moderators/coordinator/status/`] as const;
    }

    
export const getModeratorsCoordinatorStatusRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof moderatorsCoordinatorStatusRetrieve>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsCoordinatorStatusRetrieve>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getModeratorsCoordinatorStatusRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof moderatorsCoordinatorStatusRetrieve>>> = ({ signal }) => moderatorsCoordinatorStatusRetrieve(signal);

      

      

   return  { queryKey, queryFn,   staleTime: 30000, gcTime: 300000, refetchOnMount: true,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof moderatorsCoordinatorStatusRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type ModeratorsCoordinatorStatusRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof moderatorsCoordinatorStatusRetrieve>>>
export type ModeratorsCoordinatorStatusRetrieveQueryError = unknown

/**
 * @summary Coordinator status
 */
export const useModeratorsCoordinatorStatusRetrieve = <TData = Awaited<ReturnType<typeof moderatorsCoordinatorStatusRetrieve>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof moderatorsCoordinatorStatusRetrieve>>, TError, TData>>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getModeratorsCoordinatorStatusRetrieveQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Moderators can delete their own entries; super moderators any.
 * @summary Delete a time-log entry
 */
export const moderatorsCoordinatorTimeLogsDestroy = (
    id: number,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/moderators/coordinator/timeLogs/${id}/`, method: 'DELETE'
    },
      );
    }
  


export const getModeratorsCoordinatorTimeLogsDestroyMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsCoordinatorTimeLogsDestroy>>, TError,{id: number}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moderatorsCoordinatorTimeLogsDestroy>>, TError,{id: number}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moderatorsCoordinatorTimeLogsDestroy>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  moderatorsCoordinatorTimeLogsDestroy(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ModeratorsCoordinatorTimeLogsDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof moderatorsCoordinatorTimeLogsDestroy>>>
    
    export type ModeratorsCoordinatorTimeLogsDestroyMutationError = void

    /**
 * @summary Delete a time-log entry
 */
export const useModeratorsCoordinatorTimeLogsDestroy = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moderatorsCoordinatorTimeLogsDestroy>>, TError,{id: number}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof moderatorsCoordinatorTimeLogsDestroy>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getModeratorsCoordinatorTimeLogsDestroyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    